Global.store.state = {
    menuExpanded: false,
    currentLanguage: document.documentElement.lang,
    showMediaVideoModal: false,
    showSliderModal: false,
};